import { useParams } from 'react-router-dom';
import { Navigate } from 'react-router';
import { usePatientAuth } from '@/contexts/PatientAuthContext';

export function AuthenticatedSessionGuard({ children }: { children: React.ReactNode }) {
  const { token } = useParams<{ token: string }>();
  const { isAuthenticated, isLoading } = usePatientAuth();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={token ? `/s/${token}` : '/'} replace />;
  }

  return <>{children}</>;
}
